export default __webpack_public_path__ + "static/media/usd.ebdf6101.svg";